var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('b-container',[_c('div',{staticClass:"errorContainer mx-auto"},[_c('h1',{staticClass:"errorCode"},[_vm._v("404")]),_c('p',{staticClass:"errorInfo"},[_vm._v("\n          Opps, it seems that this page does not exist.\n      ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }